import { IVariant, CustomVariantValues, CustomProductItem } from './type';
export const generateNewVariantValue = () => {
  return { value: null };
};
export const generateNewVariant = (product, options) => {
  return {
    product,
    values: options.reduce((pre, now) => {
      return { ...pre, [now.id]: generateNewVariantValue() };
    }, {}),
    uuid: product.uuid,
  };
};
export const convertVariant = (variants) => {
  return variants.map((variant) => {
    const { values, product } = variant;
    return {
      product,
      values: convertValuesWhenSubmitting(values),
    };
  });
};
export const convertValuesWhenSubmitting = (
  values: IVariant<CustomVariantValues, CustomProductItem>[],
) => {
  return Object.keys(values).map((id) => {
    return {
      id: id,
      ...(values[id] || {}),
    };
  });
};
